export const DATA_REQUEST_PATHS = {
  logs: {
    requestedAt: 'log_requests.device_logs.requested_at',
    responses: 'log_responses.device_logs.logs',
    responseStatus: 'log_responses.device_logs.request_status',
  },
  bundle: {
    requestedAt: 'log_requests.bundle.requested_at',
    responses: 'log_responses.bundle.logs',
    responseStatus: 'log_responses.bundle.request_status',
  },
  flamegraph: {
    requestedAt: 'log_requests.flamegraph.requested_at',
    responses: 'log_responses.flamegraph.logs',
    responseStatus: 'log_responses.flamegraph.request_status',
  },
  metrics: {
    requestedAt: 'log_requests.device_metrics.requested_at',
    responses: 'log_responses.device_metrics.logs',
    responseStatus: 'log_responses.device_metrics.request_status',
  },
} as const

/** The time in ms to refetch devices in a pending log request state */
export const REFETCH_INTERVAL_MS = 2500

/** The number of days until the Portal will no longer poll for changes */
export const DATA_REQUEST_CUTOFF_DAYS = 2
